import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SECTIONS, FIELD_LABELS } from "@/components/admin/reportConfig";

const today = () => new Date().toISOString().slice(0, 10);

export const ReportItemForm = ({ type, initial, areas, onSubmit, onCancel, testId }) => {
  const cfg = SECTIONS[type];
  const [v, setV] = useState(() => {
    const base = { title: "", area: "", description: "", missing: "", date: ["feature", "controllo"].includes(type) ? today() : "" };
    return initial ? { ...base, ...Object.fromEntries(cfg.fields.map((f) => [f, initial[f] || ""])) } : base;
  });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = Object.fromEntries(cfg.fields.map((f) => [f, v[f]]));
    const ok = await onSubmit(payload);
    setBusy(false);
    if (ok && !initial) setV({ ...v, title: "", description: "", missing: "" });
  };

  return (
    <form onSubmit={submit} className={`space-y-3 rounded-2xl border ${cfg.border} bg-white p-4`} data-testid={testId}>
      {cfg.fields.map((f) => (
        <div key={f} className="space-y-1">
          <Label className="text-xs">{FIELD_LABELS[f]}</Label>
          {f === "description" || f === "missing" ? (
            <Textarea rows={f === "description" && type === "note" ? 4 : 2} required={type === "note"} value={v[f]} onChange={(e) => setV({ ...v, [f]: e.target.value })} data-testid={`${testId}-${f}`} />
          ) : (
            <Input type={f === "date" ? "date" : "text"} required={f === "title"} list={f === "area" ? "report-areas" : undefined} className="h-11" value={v[f]}
              onChange={(e) => setV({ ...v, [f]: e.target.value })} data-testid={`${testId}-${f}`} />
          )}
        </div>
      ))}
      <datalist id="report-areas">{areas.map((a) => <option key={a} value={a} />)}</datalist>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button type="submit" disabled={busy} className={`h-11 rounded-full text-white ${cfg.btn}`} data-testid={`${testId}-save`}>
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} {initial ? "Salva modifiche" : "Aggiungi"}
        </Button>
        <Button type="button" variant="ghost" onClick={onCancel} className="h-11 rounded-full" data-testid={`${testId}-cancel`}>Annulla</Button>
      </div>
    </form>
  );
};
